import { render, staticRenderFns } from "./WelcomeWidget.vue?vue&type=template&id=a80748f2&scoped=true&"
import script from "./WelcomeWidget.vue?vue&type=script&lang=js&"
export * from "./WelcomeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80748f2",
  null
  
)

export default component.exports